import { supabase } from "@/lib/supabase";

export type DispositionReason =
  | "Duplicate Lead"
  | "Out of Service Area"
  | "Unqualified Customer"
  | "Bad Contact Info"
  | "Price Sensitivity"
  | "Competitor Won"
  | "Other";

export interface LeadSource {
  id: string;
  name: string;
  source_type: string;
  total_leads: number;
  contacted: number;
  appointments_set: number;
  appointments_completed: number;
  monthly_cost: number;
  rejection_reasons: Record<DispositionReason, number>;
  tenant_id?: string;
  created_at: string;
  updated_at: string;
  // Aggregated fields from disposition_summary view
  sold_count?: number;
  revenue?: number;
  issue_count?: number;
  credit_amount?: number;
}

export interface LeadSourceWithAggregates extends LeadSource {
  sold_count: number;
  revenue: number;
  issue_count: number;
  credit_amount: number;
}

export const LeadSourceService = {
  async getAll() {
    const { data, error } = await supabase
      .from("lead_sources")
      .select("*")
      .order("name", { ascending: true });

    return { data: data as LeadSource[] | null, error };
  },

  async getAllWithAggregates() {
    const { data, error } = await supabase
      .from("disposition_summary")
      .select("*")
      .order("name", { ascending: true });

    return { data: data as LeadSourceWithAggregates[] | null, error };
  },

  async getById(id: string) {
    const { data, error } = await supabase
      .from("lead_sources")
      .select("*")
      .eq("id", id)
      .single();

    return { data: data as LeadSource | null, error };
  },

  async getBySourceType(sourceType: string) {
    const { data, error } = await supabase
      .from("lead_sources")
      .select("*")
      .eq("source_type", sourceType)
      .order("name", { ascending: true });

    return { data: data as LeadSource[] | null, error };
  },
};
